const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  id: state => state.user.id,
  tenantId: state => state.user.tenantId,
  avatar: state => state.user.avatar,
  logoUrl: state => state.user.logoUrl,
  name: state => state.user.name,
  userinfo: state => state.user.userinfo,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  functionKey: state => state.permission.functionKey,
  crmButtonAuth: state => state.permission.crmButtonAuth,
  orderButtonAuth: state => state.permission.orderButtonAuth,
  orderDetailAuth: state => state.permission.orderDetailAuth,
  financeButtonAuth: state => state.permission.financeButtonAuth,
  menu_list: state => state.permission.menuList,
  // 租户信息
  tenantSummaryInfo: state => state.user.tenantSummaryInfo
}
export default getters
